
export class LODProperty {
	constructor( gameService ) {
		this.gameService = gameService;
	}
	enable() {
		this.enabled = true;
		this.refresh();
	}

	disable() {
		this.enabled = false;
		this.refresh();
	}
}

export class LODPropertyLightsCastShadow extends LODProperty {

	constructor( gameService ) {

		super( gameService );

		this.additionalObjectService = angular.element( document.body ).injector().get( "additionalObjectService" );
	}

	traverseLightObjects( callback ) {
		for (var uuid in this.additionalObjectService.objects) {
			if (this.additionalObjectService.objects[ uuid ].type == 'light') {
				callback( this.additionalObjectService.objects[ uuid ] );
			}
		}
	}

	reset() {

		this.enabled = false;

		this.traverseLightObjects( light => {
			if (light.mesh && light.mesh.shadow && light.mesh.castShadow) this.enabled = true;
		});
	}

	refresh() {

		var castShadow = !!this.enabled;
		var changes = false;

		this.traverseLightObjects( light => {
			if (light.mesh && light.mesh.shadow) {
				if (light.mesh.castShadow != castShadow) {
					light.mesh.castShadow = castShadow;
					changes = true;
				}
			}
		});

		this.gameService.shadowsNeedsUpdate = true;

		return changes;
	}
}

export default class LODService {

	constructor( $rootScope, gameSceneService ) {

		this.gameService = gameSceneService;
		this.gameService.LODService = this;

		this.enabled = true;

		this.levelOfDetailProperties = {
			lightsCastShadow: new LODPropertyLightsCastShadow( this.gameService )
		};

		this.reset();

		this.levelOfDetailProperties.lightsCastShadow.enable();

		this.fpsHistory = [];
		this.fpsAverage = null;
	}

	update() {
		/*
		this.fpsHistory.unshift( this.gameService.FPS );

		var length = 80;
		var avg = null;

		if (this.fpsHistory.length < length) return;
		
		this.fpsHistory.splice( length, this.fpsHistory.length - length );

		avg = 0;
		for (let value of this.fpsHistory) avg += value;
		avg /= length;

		if (avg < 40) {

			if (this.levelOfDetailProperties.lightsCastShadow.enabled) {
				//this.levelOfDetailProperties.lightsCastShadow.disable();
			}

		} else {

			if (!this.levelOfDetailProperties.lightsCastShadow.enabled) {
				//this.levelOfDetailProperties.lightsCastShadow.enable();
			}
		}
		*/
	}

	// Päivitetään this.levelOfDetails scenen perusteella
	reset() {
		for (var key in this.levelOfDetailProperties) {
			this.levelOfDetailProperties[ key ].reset();
		}
	}
	
	// Päivitetään scene this.levelOfDetails:n perusteella
	refresh() {
		var changes = false;

		for (var key in this.levelOfDetailProperties) {
			if (this.levelOfDetailProperties[ key ].refresh()) {
				changes = true;
			}
		}

		return changes;
	}
}

LODService.$inject = [ "$rootScope", "gameSceneService" ];
